import React from "react";
import PropTypes from "prop-types";
// Material imports
import { makeStyles } from "@mui/styles";
import Grid from "@mui/material/Grid";

//Limitless imports
import LogoLandingContainer from "../../logo-landing-container/LogoLandingContainer";
import LoginWrapper from "./LoginWrapper";
const useStyles = makeStyles(theme => ({
  loginContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "calc(100vh - 170px)"
  },
  [theme.breakpoints.up("sm")]: {
    loginContainer: {
      height: "calc(100vh - 182px)"
    }
  },
  [theme.breakpoints.up("md")]: {
    loginContainer: {
      height: "calc(100vh - 260px)"
    },
    "@media (min-height:521px) and (max-height: 800px)": {
      loginContainer: {
        height: "calc(100vh - 60px)"
      }
    }
  },
  [theme.breakpoints.up("xl")]: {
    loginContainer: {
      width: "calc(100% - 12%)"
    }
  }
}));
const LoginScreenLayout = ({
  isManagerPortal
}) => {
  const classes = useStyles();
  return /*#__PURE__*/React.createElement(LogoLandingContainer, null, /*#__PURE__*/React.createElement(Grid, {
    className: classes.loginContainer
  }, /*#__PURE__*/React.createElement(LoginWrapper, {
    isManagerPortal: isManagerPortal
  })));
};
export default LoginScreenLayout;
LoginScreenLayout.propTypes = {
  isManagerPortal: PropTypes.bool.isRequired,
  classes: PropTypes.object
};